import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { LocalizationService } from 'app/core/localization/localization.service';
import { DateService } from 'app/shared/services/date.service';
import { TranslationService } from 'app/core/internationalization/translation.service';

@Injectable({
  providedIn: 'root'
})
@Pipe({
    name: 'khLocalizedDate',
    standalone: false
})
export class KhLocalizedDatePipe implements PipeTransform {
  private readonly defaultLocaleId: string;

  constructor(
    private readonly dateService: DateService, translationService: TranslationService,
    localizationService: LocalizationService) {
    this.defaultLocaleId = translationService.getCurrentLanguage() ?? localizationService.defaultLocaleId;
  }

  public transform(inputDate: Date | string, format = '', locale?: string): string {
    const LocaleId = locale ?? this.defaultLocaleId;
    return this.dateService.localeDate(new Date(inputDate), format, LocaleId);
  }
}
